module.exports = __webpack_public_path__ + "img/right3-mobile@3x.eb2ca57f.png";